import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F1120SubconsolService {

  constructor(private http: HttpClient) {}

  saveSubconsolData(
    tempobj: any,
    accountArray: any[],
    globalService: any,
    GENERAL_CONFIG: any,
    additionalParams: any
  ): Observable<any> {
    
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    // Build request parameters following original service pattern
    const filterParams = globalService?.globalParams?.filterParams || {};
    
    const jsonObj = JSON.stringify(accountArray);
    const jsonSettings = JSON.stringify(tempobj);

    let params = filterParams;
    params = Object.assign({}, globalService?.globalParams || {}, params);
    params = Object.assign({ jsonObj: jsonObj }, params);
    params = Object.assign({ jsonSettings: jsonSettings }, params);
    params = Object.assign(params, additionalParams);
    params.process_name = "CONSOL/SUBCONSOLE_DATA_SAVE";

    const baseUrl = GENERAL_CONFIG.base_url;
    const endpoint = `${baseUrl}/saveJsonObject?action_code=jcbfdm`;

    // ✅ Convert requestParams to FormData with proper type handling
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      const value = params[key];
      
      // ✅ Handle different data types properly
      if (value !== null && value !== undefined) {
        if (typeof value === 'object') {
          // Convert objects/arrays to JSON strings
          formData.append(key, JSON.stringify(value));
        } else {
          // Convert primitives to strings
          formData.append(key, String(value));
        }
      }
      // Skip null/undefined values
    });

    return this.http.post<any>(
      endpoint, 
      formData,
      { headers: headers }
    );
  } 
}